import centivoSvg from "./logo.svg?raw";
import centivoCareUrl from "./centivo-care.png";
import cignaUrl from "./cigna.png";
import mdliveUrl from "./mdlive.png";

function svgUri(svg) {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

function assetUri(url) {
    if (!url || typeof window === "undefined") return url || "";
    try {
        return new URL(url, window.location.href).href;
    } catch {
        return url;
    }
}

const BRANDS = [
    { id: "cigna", match: /cigna/i, src: () => assetUri(cignaUrl) },
    { id: "centivo-care", match: /centivo\s*care/i, src: () => assetUri(centivoCareUrl) },
    { id: "centivo", match: /centivo/i, src: () => svgUri(centivoSvg) },
    { id: "mdlive", match: /md\s*live/i, src: () => assetUri(mdliveUrl) },
];

export const PLAN_LOGO_FIELDS = new Set(["planAdministrator", "network", "virtualPrimaryCare"]);

/** PDsLF leaves Virtual Primary Care blank and floats the logo on the cell. */
export function virtualPrimaryCareBrand(network) {
    const text = String(network ?? "");
    if (/cigna/i.test(text)) return "MDLIVE";
    if (/centivo/i.test(text)) return "Centivo Care";
    return "";
}

/** PDsLF leaves Plan Administrator blank and floats the Centivo wordmark on every offered plan. */
export function planAdministratorBrand(plan) {
    const offered = Object.entries(plan || {}).some(([key, value]) => (
        key !== "planAdministrator" && String(value ?? "").trim()
    ));
    return offered ? "CENTIVO" : "";
}

const FIT_FIELDS = new Set(["planAdministrator", "network", "virtualPrimaryCare"]);

export function brandLogoHtml(value, field = "") {
    const text = String(value ?? "").trim();
    if (!text) return "";
    const brand = BRANDS.find((item) => item.match.test(text));
    if (!brand) return "";
    const alt = text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    const fit = FIT_FIELDS.has(field) ? " is-fit" : "";
    return `<img class="tpl-data-cell-logo${fit} is-${brand.id}" src="${brand.src()}" alt="${alt}">`;
}
